import { px2Rem } from '../themes/Mixins'

export default {
  baseFontWeight: 'normal',
  basePadding: '0',
  baseMargin: '0',
  baseBorderRadidus: '0',
  btnMargin: `0 auto`,
  descPadding: `${px2Rem(30)} ${px2Rem(145)} 0`
}

export const ZIndex = {
  tiny: '-1',
  base: '1',
  medium: '2',
  large: '3',
  modal: '1000'
}



// WEBPACK FOOTER //
// ./src/themes/Metrics.js